import { render, staticRenderFns } from "./Transcriptions.vue?vue&type=template&id=59630f7c"
import script from "./Transcriptions.vue?vue&type=script&lang=js"
export * from "./Transcriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports